import React from 'react';
import { Icon } from './Icon.js';
export const IconBathrobe = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M6 15H18", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M12 9V21", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("path", { d: "M8 3L11.5703 9H12H12.4297L16 3", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("path", { d: "M6 19H2L2 6L8 3H16L22 6V19H18", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M6 10V21H18V10", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" })));
};
//# sourceMappingURL=IconBathrobe.js.map